import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const VALUATION_METRICS = [
  {
    metricId: '8',
    displayName: 'Automated Valuation Observations',
    definition:
      'The total number of Automated Valuations that have been run within the geography. <br /> <br /> <br /> <b>Unavailable geographies: Council</b>',
    isAvailableInAU: true,
    isAvailableInNZ: true,
  },
  {
    metricId: '9',
    displayName: 'AVM Value Change (3 months)',
    definition:
      'The difference between the current median value and the median value three months prior. <br /> <br /> <br /> <b>Unavailable geographies: Council, Postcode</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '11',
    displayName: 'Median Value (monthly)',
    definition:
      'The middle value of all properties across the geography based on the Automated Valuation Model. <br /> <br /> <br /> <b>Unavailable geographies: Council</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '17',
    displayName: 'Median Value Accumulation (monthly)',
    definition:
      'Growth between the last sale price and the current AVM value expressed in dollar terms. <br /> <br /> <br /> <b>Unavailable geographies: Council</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '18',
    displayName: 'Median Value Accumulation (%)',
    definition:
      'Growth between the last sale price and the current AVM value expressed as a percentage. <br /> <br /> <br /> <b>Unavailable geographies: Council</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '72',
    displayName: 'AVM Value Change (5 years)',
    definition:
      'The difference between the current median value and the median value five years prior.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '73',
    displayName: 'Stratified Median Value (monthly)',
    definition:
      'The stratified median value of all properties across the geography based on the Automated Valuation Model.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '83',
    displayName: 'AVM Value Change (3 months)',
    definition:
      'The difference between the current median value and the median value three months prior.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '84',
    displayName: 'AVM Value Change (12 months)',
    definition:
      'The difference between the current median value and the median value one year prior.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '85',
    displayName: 'AVM Value Change (3 years)',
    definition:
      'The difference between the current median value and the median value three years prior.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '86',
    displayName: 'Average Value',
    definition:
      'The average value of all developed residential properties in the area based on the latest monthly property value index.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '87',
    displayName: 'Annual Property Value Change',
    definition:
      'The difference between the current average value and the average value one year prior.',
    isAvailableInAU: false,
    isAvailableInNZ: true,
  },
  {
    metricId: '88',
    displayName: 'Change in Median Value (12 months)',
    definition:
      'The difference between the median value in the current period compared to the same period 12 months ago. The result is expressed as a percentage. <br /> <br /> <br /> <b>Unavailable geographies: Council, Postcode</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '89',
    displayName: 'Change in Median Value (3 years)',
    definition:
      'The difference between the median value in the current period compared to the same period three years ago. The result is expressed as a percentage. <br /> <br /> <br /> <b>Unavailable geographies: Council, Postcode</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '90',
    displayName: 'Change in Median Value (5 years)',
    definition:
      'The difference between the median value in the current period compared to the same period five years ago. The result is expressed as a percentage. <br /> <br /> <br /> <b>Unavailable geographies: Council, Postcode</b>',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
];

export const ValuationMetrics = () => {
  const country = useRootStore(state => state.country);

  return (
    <>
      <Typography id="valuation-metrics" variant="h6" fontWeight={600} my={0.5}>
        Valuation Metrics
      </Typography>

      <Typography variant="body2">
        The Valuation metrics provide statistics based off property's valuation
        amounts.
      </Typography>

      <br />

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ whiteSpace: 'nowrap' }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Display Name</TableCell>
              <TableCell>Definition</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {VALUATION_METRICS.filter(metric =>
              country === 'au'
                ? metric.isAvailableInAU
                : metric.isAvailableInNZ,
            ).map(metric => (
              <TableRow>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.metricId}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.displayName}
                </TableCell>
                <TableCell
                  dangerouslySetInnerHTML={{ __html: metric.definition }}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
